// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__26ptl","sectionLabel":"styles_sectionLabel__2C09W","buttons":"styles_buttons__3j9-v"};